<template>
  <div class="productSort">
    <form @submit.prevent="submitForm">
      <div class="header acea-row row-center-wrapper" ref="header">
        <div class="acea-row row-between-wrapper input">
          <span class="iconfont icon-sousuo"></span>
          <input type="text" placeholder="搜索商品信息" v-model="search" />
        </div>
      </div>
    </form>
    <div class="aside">
      <div
        class="item acea-row row-center-wrapper"
        :class="index === navActive ? 'on' : ''"
        v-for="(item, index) in category"
        :key="index"
        @click="asideTap(index)"
      >
        <span>{{ item.cate_name }}</span>
      </div>
    </div>
    <div class="conter" @scroll.native="onScroll">
      <div class="listw" v-for="(item, index) in category" :key="index">
        <div ref="title" >
          <div v-for="(s_item, s_index) in item.son" :key="s_index">
            <div  class="title acea-row row-center-wrapper" >
              <!-- <div class="line"></div> -->
              <div class="name">{{ s_item.cate_name }}</div>
              <!-- <div class="line"></div> -->
            </div>
            <div class="list acea-row">
              <router-link
                class="item acea-row row-column row-middle"
                v-for="(child, index) in s_item.son"
                :key="index"
                :to="{
                  path: '/goods_list',
                  query: { id: child.id, title: child.cate_name, type: 1 },
                }"
              >
                <div class="picture"><img :src="child.image" /></div>
                <div class="name line1">{{ child.cate_name }}</div>
              </router-link>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div style="height:1.2rem;"></div>
  </div>
</template>
<script>
import debounce from "lodash.debounce";
import { getCategory, getCategoryLower } from "@api/store";
import { trim } from "../../utils";

export default {
  name: "GoodsClass",
  components: {},
  props: {},
  data: function() {
    return {
      category: [],
      navActive: 0,
      search: "",
      lock: false
    };
  },
  watch: {
    "$route.params.pid": function(n) {
      if (n) {
        this.activeCateId(n);
      }
    }
  },
  mounted: function() {
    document.addEventListener("scroll", this.onScroll, false);
    // document.addEventListener("scroll", this.onScrollAside, true);
    this.loadCategoryData();

  },
  methods: {
    activeCateId(n) {
      let index = 0;
      n = parseInt(n);
      if (!n) return;
      this.category.forEach((cate, i) => {
        if (cate.id === n) index = i;
      });

      if (index !== this.navActive) {
        this.asideTap(index);
      }
    },
    loadCategoryData() {
      getCategory({new:1}).then(res => {
        this.category = res.data.category_list;
        this.$nextTick(() => {
          if (this.$route.params.pid) this.activeCateId(this.$route.params.pid);
          else this.onScroll();
          this.loadCategoryLower()
        });
      });
      // getCategory({}).then(res => {
      //   this.category = res.data.category_list;
      //   this.$nextTick(() => {
      //     if (this.$route.params.pid) this.activeCateId(this.$route.params.pid);
      //     else this.onScroll();
      //   });
      // });
    },
    loadCategoryLower(){
      var that = this
      // forEach(this.category)
      this.category.forEach((d, index) => {
        // console.log(index)
        if(d.son){
          if(d.son.length == 0){
            getCategoryLower({pid:d.id}).then(res => {
              // console.log(res)
              that.category[index].son = res.data.category_list
            })
          }
        }

      })
      // console.log(this.category)
    },
    submitForm: function() {
      var val = trim(this.search);
      if (val) {
        this.$router.push({
          path: "/goods_list",
          query: { s: val }
        });
        setTimeout(() => (this.search = ""), 500);
      }
    },
    asideTap(index) {
      const top =
        this.$refs.title[index].offsetTop -
        this.$refs.header.offsetHeight -
        window.scrollY;

      this.lock = true;

      window.scrollBy({ top, left: 0, behavior: "smooth" });
      this.navActive = index;
    },
    onScroll: debounce(function() {
      var that = this
      if (this.lock) {
        this.lock = false;
        return;
      }
      const headerHeight = this.$refs.header.offsetHeight,
        { scrollY } = window,
        titles = this.$refs.title;
      titles.reduce((initial, title, index) => {
        if (initial) return initial;
        const parent = title.parentNode || title.parentElement;
        if (
          scrollY + headerHeight + 15 <
          title.offsetTop + parent.offsetHeight
        ) {
          initial = true;
          this.navActive = index;
        }
        return initial;
      }, false);
    }, 500),
  },

  beforeDestroy: function() {
    document.removeEventListener("scroll", this.onScroll, false);
    // document.removeEventListener("scrollAside", this.onScrollAside, false);
  }
};
</script>
